import TableauDashboardList from "./dashboardlist";
import LoginForm from "./login";
// import Dashboard from "./dashboard";

const { default: navValues } = require("../helpers/navValues");

const ComponentPicker = ({currentNavLocation}) => {
    switch(currentNavLocation){
        case navValues.home:
            return <LoginForm />;
        case navValues.dashboards:
            return <TableauDashboardList />;
        default:
            return (
                <h3>No component for navigation value {currentNavLocation} found</h3>
            );
    }
};

export default ComponentPicker;